import type { Appearance } from '../state/app-data';

// DE: Farbe der Browserleiste (Android) und der Statusleiste in Safari, passend zum Seitenhintergrund.
// EN: Colour of the browser bar (Android) and Safari's status bar, matching the page background.
const BAR_COLOURS = { dark: '#262626', light: '#F4F3EF' } as const;

/**
 * DE: Dunkel, wenn so gewählt oder wenn „wie am Telefon“ gilt und das Telefon dunkel ist.
 * EN: Dark when chosen so, or when "as on the phone" applies and the phone is dark.
 */
export function isDarkTheme(appearance: Appearance | undefined, phoneIsDark: boolean): boolean {
  if (appearance === 'dark') return true;
  if (appearance === 'light') return false;
  return phoneIsDark;
}

/**
 * DE: Thema anwenden: Ionic-Klasse, Farbschema für native Felder und Farbe der Leiste.
 * EN: Apply the theme: Ionic class, colour scheme for native controls and the bar colour.
 */
export function applyTheme(root: HTMLElement, dark: boolean): void {
  const scheme = dark ? 'dark' : 'light';
  root.classList.toggle('ion-palette-dark', dark);
  root.style.colorScheme = scheme;
  const bar = root.ownerDocument.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (bar) bar.content = BAR_COLOURS[scheme];
}
